document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.testimonial-btn');
  let currentVideo = null;
  let currentDialog = null;
    let currentVideoWrapper = null;
  let currentVideoContainer = null;
  let currentBtnMute = null;

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const videoUrl = btn.getAttribute('data-video-url');
      if (!videoUrl) return;

      const dialogId = btn.getAttribute('data-dialog-id');
      currentDialog = document.getElementById(dialogId);
      if (!currentDialog) return;

      currentVideoContainer = currentDialog.querySelector('.js-video-container');
      currentVideoWrapper = currentDialog.querySelector('.js-video-wrapper');
      const btnCloses = currentDialog.querySelectorAll('.js-btn-close-dialog');
      currentBtnMute = currentDialog.querySelector('.js-btn-mute-dialog');
      const btnPlayPauseOverlay = currentDialog.querySelector('.js-btn-play-pause-overlay');
      const posterUrl = btn.getAttribute('data-poster-url');

      // Pre-emptively set aspect ratio based on the thumbnail image if it exists
      const img = btn.querySelector('img');
      if (img && img.naturalWidth && img.naturalHeight) {
        const isDesktop = window.innerWidth >= 1024;
        const hasProduct = currentDialog.classList.contains('has-product');
        
        currentVideoWrapper.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
        
        if (isDesktop && hasProduct) {
          // On desktop, the wrapper needs max constraints so it doesn't overflow the container
          currentVideoWrapper.style.maxHeight = '100%';
          currentVideoWrapper.style.maxWidth = '100%';
          currentVideoWrapper.style.height = 'auto';
          currentVideoWrapper.style.width = 'auto';
        } else {
           // On mobile, just let the container enforce the aspect ratio
           currentVideoContainer.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
        }
        
        const ratio = img.naturalWidth / img.naturalHeight;
        if (ratio > 0.6) {
          currentVideoContainer.classList.add('is-non-vertical');
        }
      } else {
        currentVideoWrapper.style.aspectRatio = '9 / 16';
        const isDesktop = window.innerWidth >= 1024;
        const hasProduct = currentDialog.classList.contains('has-product');
        
        if (isDesktop && hasProduct) {
          currentVideoWrapper.style.maxHeight = '100%';
          currentVideoWrapper.style.maxWidth = '100%';
          currentVideoWrapper.style.height = 'auto';
          currentVideoWrapper.style.width = 'auto';
        } else {
          currentVideoContainer.style.aspectRatio = '9 / 16';
        }
      }

      currentVideo = document.createElement('video');
      currentVideo.src = videoUrl;
      if (posterUrl) {
        currentVideo.poster = posterUrl;
      }
      
      currentVideo.autoplay = true;
      currentVideo.playsInline = true;
      currentVideo.muted = false;

      currentVideo.addEventListener('loadedmetadata', () => {
        if (!currentVideoContainer || !currentVideoWrapper) return;
        const isDesktop = window.innerWidth >= 1024;
        const hasProduct = currentDialog.classList.contains('has-product');
        
        currentVideoWrapper.style.aspectRatio = `${currentVideo.videoWidth} / ${currentVideo.videoHeight}`;

        if (isDesktop && hasProduct) {
           currentVideoWrapper.style.maxHeight = '100%';
           currentVideoWrapper.style.maxWidth = '100%';
           currentVideoWrapper.style.height = 'auto';
           currentVideoWrapper.style.width = 'auto';
        } else {
           currentVideoContainer.style.aspectRatio = `${currentVideo.videoWidth} / ${currentVideo.videoHeight}`;
        }
        
        const ratio = currentVideo.videoWidth / currentVideo.videoHeight;
        if (ratio > 0.6) {
          currentVideoContainer.classList.add('is-non-vertical');
        } else {
          currentVideoContainer.classList.remove('is-non-vertical');
        }
      });

      currentVideo.addEventListener('click', () => {
        if (currentVideo.paused) {
          currentVideo.play();
        } else {
          currentVideo.pause();
        }
      });

      currentVideo.addEventListener('play', () => {
        if (currentVideoContainer) {
          currentVideoContainer.classList.remove('is-paused');
        }
      });
      
      currentVideo.addEventListener('pause', () => {
        if (currentVideoContainer) {
          currentVideoContainer.classList.add('is-paused');
        }
      });

      currentVideo.addEventListener('volumechange', () => {
        if (currentBtnMute) {
          if (currentVideo.muted) {
            currentBtnMute.classList.add('is-muted');
          } else {
            currentBtnMute.classList.remove('is-muted');
          }
        }
      });

      const playPromise = currentVideo.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          if (currentVideoContainer) {
            currentVideoContainer.classList.add('is-paused');
          }
        });
      }

      currentVideoWrapper.appendChild(currentVideo);
      currentDialog.showModal();

      // Initialize product forms if they haven't been already
      if (window.initProductForms) {
        window.initProductForms();
      } else {
        initFallbackProductForms();
      }
      
      initMobileForms();

      // Re-initialize swiper if it exists in the dialog
      const productSwiper = currentDialog.querySelector('product-swiper');
      if (productSwiper && typeof productSwiper.initSwiper === 'function') {
        productSwiper.initSwiper();
      }

      // Add listeners for this specific dialog
      currentDialog.addEventListener('close', cleanupDialog);
      
      btnCloses.forEach(btn => {
        btn.addEventListener('click', closeDialog);
      });
      
      currentDialog.addEventListener('click', (e) => {
        if (e.target === currentDialog) {
          closeDialog();
        }
      });

      btnPlayPauseOverlay.addEventListener('click', () => {
        if (!currentVideo) return;
        if (currentVideo.paused) {
          currentVideo.play();
        } else {
          currentVideo.pause();
        }
      });

      currentBtnMute.addEventListener('click', () => {
        if (!currentVideo) return;
        currentVideo.muted = !currentVideo.muted;
      });
    });
  });

  const cleanupDialog = () => {
    if (currentVideo) {
      currentVideo.remove();
      currentVideo = null;
    }
    if (currentVideoContainer) {
      currentVideoContainer.classList.remove('is-paused');
      currentVideoContainer.classList.remove('is-non-vertical');
      currentVideoContainer.style.aspectRatio = '';
    }
    if (currentVideoWrapper) {
      currentVideoWrapper.style.aspectRatio = '';
      currentVideoWrapper.style.maxHeight = '';
      currentVideoWrapper.style.maxWidth = '';
      currentVideoWrapper.style.height = '';
      currentVideoWrapper.style.width = '';
    }
    if (currentBtnMute) {
      currentBtnMute.classList.remove('is-muted');
    }
    currentDialog = null;
    currentVideoContainer = null;
    currentVideoWrapper = null;
    currentBtnMute = null;
  };

  const closeDialog = () => {
    if (currentDialog) {
      currentDialog.close();
    }
  };
  // Mobile form submission
  const initMobileForms = () => {
    const mobileForms = document.querySelectorAll('.testimonial-mobile-form');
    mobileForms.forEach(form => {
      // Prevent multiple initializations
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const btn = form.querySelector('.js-add-to-cart-btn-mobile');
        const originalBtnText = btn ? btn.textContent : '';
        
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding...';
        }

        const formData = new FormData(form);
        const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

        fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(() => {
          if (typeof window.showToast === 'function') {
            window.showToast('Item added to cart!');
          }

          // Update header cart count and the cart itself if we're on the cart page
          fetch(rootUrl + '?sections=header,cart')
            .then(res => res.json())
            .then(sections => {
              // Update Header Cart Count
              const headerHtml = sections['header'];
              if (headerHtml) {
                const parsedHeader = new DOMParser().parseFromString(headerHtml, 'text/html');
                const newCartBubble = parsedHeader.querySelector('#cart-icon-bubble');
                const currentCartBubble = document.getElementById('cart-icon-bubble');
                
                if (newCartBubble && currentCartBubble) {
                  currentCartBubble.innerHTML = newCartBubble.innerHTML;
                }
              }

              // Update Cart Items if we are on the cart page
              const cartHtml = sections['cart'];
              if (cartHtml) {
                 const parsedCart = new DOMParser().parseFromString(cartHtml, 'text/html');
                 const newCartContainer = parsedCart.querySelector('.cart-container');
                 const currentCartContainer = document.querySelector('.cart-container');
                 if (newCartContainer && currentCartContainer) {
                    currentCartContainer.innerHTML = newCartContainer.innerHTML;
                 }
              }
            });
        })
        .catch((error) => {
          console.error('Error adding to cart:', error);
          alert('Error adding item to cart.');
        })
        .finally(() => {
          if (btn) {
            btn.disabled = false;
            btn.textContent = originalBtnText;
          }
        });
      });
    });
  };

  const initFallbackProductForms = () => {
    const productInfos = document.querySelectorAll('.product-info');

    productInfos.forEach(container => {
      // Prevent multiple initializations
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      const variantRadios = container.querySelectorAll('.variant-radio');
      const variantIdInput = container.querySelector('.js-product-variant-id');
      const inventoryMessage = container.querySelector('.js-inventory-message');
      const priceElement = container.querySelector('.js-product-price');
      const quantityInput = container.querySelector('.quantity-input');
      const quantityBtns = container.querySelectorAll('.quantity-btn');
      const addToCartBtn = container.querySelector('.js-add-to-cart-btn');
      const checkoutBtnWrapper = container.querySelector('.js-checkout-button-wrapper');

      const variantsDataEl = container.querySelector('.js-product-variants-data');
      const variantsData = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];

      function updateVariant() {
        if(!variantsData || variantsData.length === 0) return;
        
        const selectedOptions = Array.from(container.querySelectorAll('.variant-radio:checked')).map(r => r.value);
        
        const matchedVariant = variantsData.find(variant => {
          if(variant.options) {
             return variant.options.every((option, index) => option === selectedOptions[index]);
          }
          return false;
        });

        if (matchedVariant) {
          if (variantIdInput) variantIdInput.value = matchedVariant.id;
          
          // Update price using Shopify's pre-formatted string
          if (priceElement) {
            let isSoldOut = !matchedVariant.available;
            let isOnSale = matchedVariant.compare_at_price > matchedVariant.price && !isSoldOut;

            if (isOnSale) {
               let discountAmount = matchedVariant.compare_at_price - matchedVariant.price;
               let discountPercentage = Math.round((discountAmount * 100) / matchedVariant.compare_at_price);

               priceElement.innerHTML = `
                  <s class="product-price-compare">${matchedVariant.compare_at_price_formatted}</s>
                  <span class="product-price-sale">${matchedVariant.price_formatted}</span>
                  <span class="product-badge-sale">-${discountPercentage}%</span>
               `;
               
               if (checkoutBtnWrapper) {
                  checkoutBtnWrapper.classList.add('is-on-sale');
               }
            } else {
               priceElement.innerHTML = `<span class="product-price-regular">${matchedVariant.price_formatted}</span>`;
               
               if (checkoutBtnWrapper) {
                  checkoutBtnWrapper.classList.remove('is-on-sale');
               }
            }
          }

          // Update pills UI
          container.querySelectorAll('.variant-pill').forEach(pill => {
            pill.classList.remove('is-active');
          });
          
          variantRadios.forEach(radio => {
            if (radio.checked) {
              const pill = radio.closest('.variant-pill');
              if (pill) pill.classList.add('is-active');
            }
          });

          // Update Inventory message and Buttons
          if (matchedVariant.available) {
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
            }
            if (checkoutBtnWrapper) {
              checkoutBtnWrapper.classList.remove('is-disabled');
            }
            
            if (quantityInput) {
              quantityInput.disabled = false;
              const quantityWrapper = container.querySelector('.quantity-input-wrapper');
              if (quantityWrapper) quantityWrapper.classList.remove('is-disabled');
            }
            if (quantityBtns) {
              quantityBtns.forEach(btn => btn.disabled = false);
            }

            if (inventoryMessage) {
              if (matchedVariant.inventory_management !== null && matchedVariant.inventory_quantity <= 5 && matchedVariant.inventory_quantity > 0) {
                inventoryMessage.textContent = 'Low on stock';
              } else {
                inventoryMessage.textContent = '';
              }
            }
          } else {
            if (addToCartBtn) {
              addToCartBtn.disabled = true;
            }
            if (checkoutBtnWrapper) {
              checkoutBtnWrapper.classList.add('is-disabled');
            }
            
            if (quantityInput) {
              quantityInput.disabled = true;
              const quantityWrapper = container.querySelector('.quantity-input-wrapper');
              if (quantityWrapper) quantityWrapper.classList.add('is-disabled');
            }
            if (quantityBtns) {
              quantityBtns.forEach(btn => btn.disabled = true);
            }
            
            if (inventoryMessage) {
              inventoryMessage.textContent = 'Sold out';
            }
          }
          
          // Update main image if variant has one - only within this container context if needed
          if (matchedVariant.featured_image_url) {
             const localMainImage = container.querySelector('.js-main-product-image') || document.getElementById('main-product-image');
             if(localMainImage) {
                 localMainImage.src = matchedVariant.featured_image_url;
                 localMainImage.removeAttribute('srcset');
             }
          }
        }
      }

      variantRadios.forEach(radio => {
        radio.addEventListener('change', updateVariant);
      });

      quantityBtns.forEach(btn => {
        btn.addEventListener('click', function() {
          if (!quantityInput) return;
          let currentVal = parseInt(quantityInput.value, 10);
          if (isNaN(currentVal)) currentVal = 1;
          
          if (this.dataset.action === 'plus') {
            quantityInput.value = (currentVal + 1).toString().padStart(2, '0');
          } else if (this.dataset.action === 'minus' && currentVal > 1) {
            quantityInput.value = (currentVal - 1).toString().padStart(2, '0');
          }
        });
      });
      
      // Format initial quantity if it's not already padded
      if(quantityInput) {
         let currentVal = parseInt(quantityInput.value, 10);
         if (!isNaN(currentVal)) {
            quantityInput.value = currentVal.toString().padStart(2, '0');
         }
      }

      // Handle Add to Cart AJAX
      const productForm = container.querySelector('.product-form-element');
      if (productForm) {
        productForm.addEventListener('submit', function(e) {
          if (document.activeElement && document.activeElement.classList.contains('shopify-payment-button__button')) {
            // Let the default buy now action happen
            return;
          }
          e.preventDefault();
          
          const formData = new FormData(productForm);
          
          const originalBtnText = addToCartBtn ? addToCartBtn.textContent : '';
          if (addToCartBtn) {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = 'Adding...';
          }

          const rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

          fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            body: formData
          })
          .then(response => {
            return response.json();
          })
          .then(() => {
            if (typeof window.showToast === 'function') {
              window.showToast('Item added to cart!');
            }

            // Update header cart count and the cart itself if we're on the cart page
            fetch(rootUrl + '?sections=header,cart')
              .then(res => res.json())
              .then(sections => {
                // Update Header Cart Count
                const headerHtml = sections['header'];
                if (headerHtml) {
                  const parsedHeader = new DOMParser().parseFromString(headerHtml, 'text/html');
                  const newCartBubble = parsedHeader.querySelector('#cart-icon-bubble');
                  const currentCartBubble = document.getElementById('cart-icon-bubble');
                  
                  if (newCartBubble && currentCartBubble) {
                    currentCartBubble.innerHTML = newCartBubble.innerHTML;
                  }
                }

                // Update Cart Items if we are on the cart page
                const cartHtml = sections['cart'];
                if (cartHtml) {
                   const parsedCart = new DOMParser().parseFromString(cartHtml, 'text/html');
                   const newCartContainer = parsedCart.querySelector('.cart-container');
                   const currentCartContainer = document.querySelector('.cart-container');
                   if (newCartContainer && currentCartContainer) {
                      currentCartContainer.innerHTML = newCartContainer.innerHTML;
                   }
                }
              });
          })
          .catch((error) => {
            console.error('Error adding to cart:', error);
            alert('Error adding item to cart.');
          })
          .finally(() => {
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              addToCartBtn.textContent = originalBtnText;
            }
          });
        });
      }
    });

    const productGalleryDesktop = document.querySelectorAll('.product-gallery-desktop');
    // Handle Thumbnail Clicks - scoped for forms
    productGalleryDesktop.forEach(container => {
      const thumbnails = container.querySelectorAll('.desktop-thumbnail, .js-desktop-thumbnail');
      thumbnails.forEach(thumbnail => {
        // Prevent multiple listeners
        if (thumbnail.dataset.listenerAdded) return;
        thumbnail.dataset.listenerAdded = 'true';

        thumbnail.addEventListener('click', function(e) {
          if (e.target.closest('.video-thumbnail-btn')) {
            return;
          }
          const largeImageUrl = this.getAttribute('data-large-image');
          if (largeImageUrl) {
             const mainImage = container.querySelector('.js-main-product-image') || document.getElementById('main-product-image');
             if (mainImage) {
               mainImage.src = largeImageUrl;
               mainImage.removeAttribute('srcset'); // Force browser to use the new src
             }
          }
        });
      });
    });
  };
});
